<template>
    <main class="resource flex flex-align" v-if="resource">
        <div class="ff">
            <h2 class="text-overflow">{{resource.title}}</h2>
            <h3 class="text-overflow" v-if="resource.metadata.description">{{resource.metadata.description}}</h3>
        </div>
        <router-link :to="{name: 'assignment'}" target="_blank" class="button">Open Assignment</router-link>
    </main>
</template>

<script>
    export default {
        name: 'Launch',
        data(){
            return {
                loading: false,
                resource: null
            };
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            chapter(){
                return this.$store.getters.chapter;
            },
            user(){
                return this.$store.state.user;
            },
            active(){
                return this.$route.params.resource;
            },
            type(){
                if(types.hasOwnProperty(this.resource.type)){
                    return types[this.resource.type];
                }

                return this.resource.type;
            }
        },
        created(){
            this.$http.get(`/code/${this.$route.params.assignment}`)
            .then(response => {
                this.resource = response.$data;
            });
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .resource
    {
        width: 100%;
        height: 82px;
        border-radius: 5px;
        border: 1px solid @e4;
        padding: 15px 20px;

        h2
        {
            font-size: 20px;
            font-weight: 700;
            color: @black;
            line-height: 24px;
            letter-spacing: -0.03rem;
        }

        h3
        {
            font-size: 15px;
            color: @grey;
            font-weight: 400;
            line-height: 18px;
            margin-top: 4px;
        }

        .button
        {
            margin-left: 30px;
        }
    }
</style>